var _ = require("lodash");

var { ObjectId, TypedArrayId, FormatTypeId, NumberId } = require("../typing/typing");

var MessageId = ObjectId;

function TextMessage(text) {
  if(_.keys(this).length > 0) return new TextMessage(text);
  this.type = "text";
  this.text = text;
}

function HTMLMessage(html) {
  if(_.keys(this).length > 0) return new HTMLMessage(html);
  this.type = "html";
  this.html = html;
}

function ImgMessage(imgsrc) {
  if(_.keys(this).length > 0) return new ImgMessage(imgsrc);
  this.type = "img";
  this.src  = imgsrc;
}

function AdressedMessage(subj, msg) {
  if(_.keys(this).length > 0) return new AdressedMessage(subj, msg);
  this.type = "adressed";
  this.subj = subj;
  this.msg = msg;
}

function ComposedMessage(parts) {
  if(_.keys(this).length > 0) return new ComposedMessage(parts);
  this.type = "composed";
  this.parts = parts;
}

function AppliedMessage(msg, backward) {
  if(_.keys(this).length > 0) return new AppliedMessage(msg, backward);
  this.type = "applied";
  this.msg = msg;
  this.backward = !!backward;
}

function FormatMessage(msg, rules) {
  if(_.keys(this).length > 0) return new FormatMessage(msg, rules);
  this.type = "format";
  this.msg = msg;
  this.rules = rules;
}

///////////////////////////////////////////////////////////////////////////////

/**
 * getMsgObject(msg, time) transforms a message formed by a process interpreter
 *   to an object whose keys are subjects mentioned in msg
 *   and values are one-element arrays of pairs { time, msg }
 *
 * It interprets msg object formed by ShowText or Option with specific structure
 *   (i.e. without timestamps, subject addresing within msg etc)
 *   and returns a message object in the appropriate format:
 *   { subj: [ { time, msg } ] }
 *
 * This method collects all the subjects which subparts are adressed to.
 *
 * If msg has no 'adressed' subpart, it is returned with minor modifications.
 *
 * The second argument 'time' is optional. If time is not given,
 *   an object of arrays of messages is returned
 */
function getMsgObject(msg, time) {
  if(!msg) return msg;
  if(time !== undefined) {
    var m = getMsgObject(msg);
    if(m.type) return m; // no 'applied' subpart
    return _.mapValues(m, function(pm) { return [ { time: time, msg: pm } ]; });
  }
  if(_.isString(msg)) return { type: "text", text: msg };
  switch (msg.type) {
    case "adressed":
      var m = getMsgObject(msg.msg);
      var res = {};
      res[msg.subj] = m.type ? m : m[msg.subj] ;
      return res;
    case "composed":
      if(msg.parts.type == "RefText") return msg;
      var arr = msg.parts
        .map(function(part) { return getMsgObject(part); })
        .filter(function(res) { return res !== undefined; });
      // flatten nested composed messages
      arr = _.flatMap(arr, function(m) {
        return m.type == "composed" ? m.parts : [m];
      });
      if(arr.length == 0) return undefined;
      var adressedParts = arr.filter(function(m) { return !m.type; });
      if(adressedParts.length > 0)
        return adressedParts.reduce(concatMsgWithoutCollapse);
      return { type: "composed", parts: arr };
    case "text":
    case "html":
    case "img":
      return msg;
    case "applied":
      var m = getMsgObject(msg.msg);
      if(!m) return m;
      var wrap = function(m) {
        return { type: "applied", msg: m, backward: msg.backward };
      };
      if(!m.type) return _.mapValues(m, wrap);
      return wrap(m);
    case "format":
      var m = getMsgObject(msg.msg);
      if(!m) return m;
      var wrap = function(m) {
         return { type: "format", msg: m, rules: msg.rules };
      };
      if(!m.type) return _.mapValues(m, wrap);
      // distribution 'format' rules over 'composed' parts
      if(m.type == "composed") {
        m.parts = m.parts.map(wrap);
        return m;
      } else wrap(m);
  }
  return msg;
}

/**
 * concatMsgWithoutCollapse is a monoidal composition of two msgObj,
 *   each of which is of the format { subj: [ { time, msg } ] }
 * This function does not treat 'applied' messages' semantic
 */
function concatMsgWithoutCollapse(msgObj1, msgObj2) {
  function customizer(arr1, arr2) {
    if(arr1 && arr2)
      return _.filter(_.concat(arr1, arr2),
        function(m) { return m !== undefined && (m.time === undefined || m.msg !== undefined); });
  }
  return _.mergeWith(_.cloneDeep(msgObj1), msgObj2, customizer);
}

/* extractAppliedMsg decomposes msg, extracting 'applied' parts of 'composed' messages
 * it returns { backward: [ array of applied ], now: [ parts of msg without applied subparts ], forward: [ … ] }
 */
function extractAppliedMsg(msg) {
    if(!msg) return { backward: [], now: [], forward: [] };
    if(msg.type == "applied" && msg.backward)
      return { backward: [ msg.msg ], now: [], forward: [] };
    if(msg.type == "applied" && !msg.backward)
      return { backward: [], now: [], forward: [ msg.msg ] };
    if(msg.type == "composed") {
      // map + transposition + concatenation
      var extractedParts = msg.parts.map(extractAppliedMsg);
      var reducedParts = _.reduce(extractedParts,
        function(result, element) {
          return _.mergeWith(_.cloneDeep(result), element, _.ary(_.concat, 2));
        });
      // 'now' field contains an array of parts
      /*
      reducedParts.now = {
        type: "composed",
        parts: reducedParts.now
      };
      if(reducedParts.now.length == 0)
        reducedParts.now = undefined;*/
      return reducedParts;
    }
    return { backward: [], now: [msg], forward: [] };
}

function CollapseArrayOfAppliedMessages(msgArray, subj) {
  var msgArrayExtr = msgArray.map(function(m) {
    return _.merge(extractAppliedMsg(m.msg), { time: m.time });
  });
    
  var resArray = [];
    
  for(var k = 0, n = msgArray.length; k < n; ++k) {
    var parts = [];
    var time = msgArrayExtr[k].time;
    if(msgArrayExtr[k-1] && msgArrayExtr[k-1].time == time)
      parts = msgArrayExtr[k-1].forward;
    if(msgArrayExtr[k].now !== undefined)
      parts = parts.concat(msgArrayExtr[k].now);
    if(msgArrayExtr[k+1] && msgArrayExtr[k+1].time == time)
      parts = parts.concat(msgArrayExtr[k+1].backward);
    if(parts.length > 1)
      resArray.push({
        time: time,
        msg: MessageId({ type: "composed", parts: parts })
      });
    if(parts.length == 1)
      resArray.push({
        time: time,
        msg: MessageId(parts[0])
      });
  }
    
  /* This part is about the very last message */
  if(msgArrayExtr.length == 0) return [];
  var fm = _.last(msgArrayExtr);
  if(fm.forward.length > 0) {
    var fmMsg = {
      type: "applied",
      backward: false,
      msg: {
        type: "composed",
        parts: fm.forward
      }
    };
    if(resArray.length == 0)
      return (fm.forward.length > 0) ? [ { time: fm.time, msg: fmMsg } ] : [];
    var lastMsg = _.last(resArray);
    if(fmMsg && fm.time == lastMsg.time) {
      lastMsg.msg = {
        type: "composed",
        parts: [ lastMsg.msg, fmMsg ]
      };
    } else resArray.push({ time: fm.time, msg: fmMsg });
  }
    
  return resArray;
}

/**
 * concatMsg is a monoidal composition of two msgObj,
 *   each of which is of the format { subj: [ { time, msg } ] }
 */
function concatMsg(msgObj1, msgObj2) {
  return MsgObjId(
    _.mapValues(
      concatMsgWithoutCollapse(msgObj1, msgObj2),
      CollapseArrayOfAppliedMessages
    ));
}

function MsgObjId(obj) {
  return _.mapValues(obj,
    TypedArrayId(FormatTypeId({ time: NumberId, msg: MessageId })));
}


// EXPORT

module.exports = {
  getMsgObject: getMsgObject,
  concatMsg: concatMsg,
  concatMsgWithoutCollapse: concatMsgWithoutCollapse
};
